.document-field-card {
  width: 100%;
}
